import { getLabel } from "../labels";

export function getFilterDesc(filter) {
    switch (filter) {
        case '1H':
            return getLabel('prematch_page.temporal_filters.1h');
        case '3H':
            return getLabel('prematch_page.temporal_filters.3h');
        case 'TODAY':
            return getLabel('prematch_page.temporal_filters.today');
        case '2D':
            return getLabel('prematch_page.temporal_filters.2d');
        case '3D':
            return getLabel('prematch_page.temporal_filters.3d');
        case 'ALL':
            return getLabel('prematch_page.temporal_filters.all');
        default:
            return '';
    }
}
